import React from 'react';
import { NavLink } from 'react-router-dom';

import './NavigationItem.css';

const navigationItem = (props) => (
    <li className="NavigationItem">
        <NavLink
            onClick={(event) => props.closeSideBar(event)}
            exact={props.exact}
            to={props.link}
            activeClassName="active">{props.children}</NavLink>
    </li>
);

export default navigationItem;